import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import './styles.scss'

import React, { lazy, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

import { Router, withRouter, RouteComponentProps } from 'react-router-dom'
import { Provider } from 'react-redux'

import initI18n from './services/i18n'
import { history } from './services/routing'
import { store } from './services/redux'
import './services/common/validation'

import { getBrandName } from './config'

// Type definition for location state
interface LocationState {
  sectionId?: string
}

const ConnectedApp = lazy(() => {
  return import('./App')
}) as React.LazyExoticComponent<React.ComponentType>

const PositionRestore = withRouter(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props: RouteComponentProps<any, any, LocationState>) => {
    const [location, setLocation] = useState(props.location.pathname)
    if (location !== props.location.pathname) {
      setLocation(props.location.pathname)
      if (
        (props.location.state &&
          props.location.state.sectionId === undefined) ||
        (props.location.state &&
          props.location.state.sectionId &&
          props.location.state.sectionId === '')
      ) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
    }

    return null
  }
)

function Init() {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    Promise.all([initI18n(getBrandName())]).then(() => {
      setLoaded(true)
    })
  }, [])
  return loaded ? (
    <React.Suspense fallback={null}>
      {/* @ts-expect-error - Type incompatibility between React 16.8.3 and @types/react 18.x */}
      <Provider store={store}>
        {/* @ts-expect-error - Type incompatibility between React 16.8.3 and @types/react 18.x */}
        <Router history={history}>
          {/* @ts-expect-error - Type incompatibility between React 16.8.3 and @types/react 18.x */}
          <PositionRestore />
          <ConnectedApp />
        </Router>
      </Provider>
    </React.Suspense>
  ) : null
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((module as any).hot) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(module as any).hot.accept(render)
}

function render() {
  const rootElement = document.getElementById('root')
  // eslint-disable-next-line  import/no-named-as-default-member
  ReactDOM.render(<Init />, rootElement)
}

render()
